<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
    <section class="pt-[60px] pb-[40px] sm:pt-24 sm:pb-12">
        <UContainer>
            <div class="flex flex-col items-center lg:max-w-[800px] mx-auto">
                <h1 class="uppercase text-[#0A5A75] text-[30px] leading-[38px] sm:text-[46px] sm:leading-[48px] text-center">{{ t('forParents.title') }}</h1>
                <h2 class="uppercase text-[#0A5A75] text-[30px] leading-[38px] sm:text-[36px] sm:leading-[46px] text-center">{{ t('forParents.subtitle') }}</h2>
            </div>
        </UContainer>
    </section>
</template>

<style scoped>

</style>
